import React, { useMemo, useState } from "react";
import { DoughnutChart } from "../../ui/Graph";
import PropTypes from "prop-types";
import { classNames } from "../../../utils/helpers";
import { FormatInt } from "../../../utils/FormatData";
const PartnerGraphDashboard = ({ data = [], loading = false }) => {
  const [filterGraph, setFilterGraph] = useState("sms");
  const { labels, dataSets } = useMemo(() => {
    const valueKey =
      filterGraph === "sms" ? "i_sms" : filterGraph === "rcs" ? "i_rcs" : null;

    if (!valueKey) {
      return { labels: [], dataSets: [] };
    }

    const sorted = [...data]
      .map((item) => ({
        label: item.vc_partner,
        value: item[valueKey],
      }))
      .sort((a, b) => b.value - a.value);

    return {
      labels: sorted.map((item) => item.label),
      dataSets: sorted.map((item) => item.value),
    };
  }, [data, filterGraph]);

  return (
    <div className="flex flex-col gap-4 bg-white rounded-lg px-4 py-2">
      <div className="flex justify-end gap-2">
        <button
          className={classNames(
            `border-none bg-gray-200 rounded-lg px-2 py-1 text-md font-semibold hover:bg-gray-400 hover:text-white`,
            {
              "bg-gray-400 text-white": filterGraph === "sms",
            }
          )}
          onClick={() => setFilterGraph("sms")}
        >
          SMS
        </button>
        <button
          className={classNames(
            `border-none bg-gray-200 rounded-lg px-2 py-1 text-md font-semibold hover:bg-gray-400 hover:text-white`,
            {
              "bg-gray-400 text-white": filterGraph === "rcs",
            }
          )}
          onClick={() => setFilterGraph("rcs")}
        >
          RCS
        </button>
      </div>
      <DoughnutChart
        title="Distribución de Partners por SMS"
        labels={labels}
        dataSets={dataSets}
        label="No. de SMS"
        loading={loading}
      />

      <div>
        <p className="text-sm font-semibold">
          Total {filterGraph === "sms" ? "SMS" : "RCS"}:{" "}
          {FormatInt(dataSets.reduce((a, b) => a + b, 0))}
        </p>
      </div>
    </div>
  );
};

PartnerGraphDashboard.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
};

export default PartnerGraphDashboard;
